
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#000","stroke-width":"1.5","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M13.494 22.317H3.058c-.76 0-1.375-.616-1.375-1.375V3.058c0-.76.616-1.375 1.375-1.375h17.884c.76 0 1.375.616 1.375 1.375v10.436c0 .365-.145.714-.402.972l-7.449 7.449a1.375 1.375 0 01-.972.402z"}}),_c('path',{attrs:{"d":"M14.063 22.193V15.44c0-.76.616-1.376 1.376-1.376h6.754M7.185 7.185H18.19M7.185 11.312H12"}})])])
          )
        }
      }
    